module.exports = __webpack_public_path__ + "img/36.667852ca.png";